class Cards {
    constructor(options){
        if(options){
            this.client = options.client
        }
    }
    create(options){
        return this.client.post(`/cards`, options)
    }
    createToken(options){
        return this.client.post(`/cards/token`, options)
    }
}

export default Cards


// WEBPACK FOOTER //
// ./lib/apiClient/cards.js